import React from 'react';

import useStyles from 'components/StatusIndicator/StatusIndicator.styles';
import { DEFAULT_STATUS_INDICATOR_SIZE } from 'utils/defaults';

type StatusWrapperProps = {
  color: string;
  size?: string;
};

const StatusIndicator = ({ color, size = DEFAULT_STATUS_INDICATOR_SIZE }: StatusWrapperProps) => {
  const classes = useStyles({ statusColour: color, statusSize: size });

  return <div className={classes.root} data-testid="status-indicator" />;
};

export default StatusIndicator;
